import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

const LOGIN_MISMATCH_TEXT = "logins don't match";

const getErrorText = (error) =>
  [
    error?.name,
    error?.message,
    error?.code,
    error?.underlyingError?.name,
    error?.underlyingError?.message,
    error?.cause?.name,
    error?.cause?.message,
    error?.toString?.(),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

export const isCognitoLoginMismatchError = (error) =>
  getErrorText(error).includes(LOGIN_MISMATCH_TEXT);

export const clearAmplifyCredentials = async () => {
  await Amplify.Auth?.clearCredentials?.();
};

export const fetchAuthSessionWithLoginMismatchRetry = async (options) => {
  try {
    return await fetchAuthSession(options);
  } catch (error) {
    if (!isCognitoLoginMismatchError(error)) {
      throw error;
    }

    await clearAmplifyCredentials();
    return fetchAuthSession({ ...options, forceRefresh: true });
  }
};

export const retryAfterCognitoLoginMismatch = async (error, operation) => {
  if (!isCognitoLoginMismatchError(error)) {
    throw error;
  }

  await clearAmplifyCredentials();
  return operation();
};
